import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

export function PlaygroundSectionDisconnectedBy() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Default</PlaygroundSubSectionTitle>
        <Section data-test="disconnected-by-section">
          <SectionHeader>
            <SectionTitle>Disconnected by</SectionTitle>
          </SectionHeader>
          <span className="text-sm font-medium">Agent</span>
        </Section>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>External</PlaygroundSubSectionTitle>
        <Section data-test="disconnected-by-section">
          <SectionHeader>
            <SectionTitle>Disconnected by</SectionTitle>
          </SectionHeader>
          <span className="text-sm font-medium">External</span>
        </Section>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
